import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface FormNavigationProps {
  step: number;
  isSubmitting: boolean;
  isStepValid: boolean;
  onBack: () => void;
  onContinue: () => void;
}

const FormNavigation = ({
  step,
  isSubmitting,
  isStepValid,
  onBack,
  onContinue,
}: FormNavigationProps) => {
  return (
    <div className="flex justify-between">
      {step > 1 && (
        <Button
          variant="outline"
          onClick={onBack}
          className="flex items-center gap-2"
          disabled={isSubmitting}
        >
          <ArrowLeft className="w-4 h-4" /> Back
        </Button>
      )}
      <Button
        className={`${step === 1 ? "w-full" : ""}`}
        disabled={!isStepValid || isSubmitting}
        onClick={onContinue}
      >
        {isSubmitting ? "Submitting..." : step === 4 ? "Submit Quote" : "Continue"}
      </Button>
    </div>
  );
};

export default FormNavigation;